import i18n from '@/i18n'
import { COMPANY_ADMIN_MENU_GROUP_KEY } from '@/constant/company'
// import BlankLayout from '../../layout/blankLayout.vue'
import List from './list.vue'
import Edit from './editor.vue'
import Layout from '../layout.vue'

const basePath = '/v-admin/alumni/management'

export default {
  name: 'alumniManagement',
  path: `${basePath}`,
  redirect: `${basePath}/list`,
  component: Layout,
  meta: {
    isAllInclude: true,
    isNewPage: true,
    permission: ['PERM_HR_ALUMNI_MANAGEMENT', 'PREMIUM_ALUMNI_MANAGEMENT'],
    titleI18nKey: 'admin.company.alumniManagement.title',
    menu: {
      get label () {
        return i18n.t('admin.company.alumniManagement.title')
      },
      group: COMPANY_ADMIN_MENU_GROUP_KEY.COMPANY_INTERNAL
    }
  },
  children: [
    {
      path: `${basePath}/list`,
      component: List,
      meta: {
        isNewPage: true,
        breadcrumb: { hidden: true },
        titleI18nKey: 'admin.company.alumniManagement.title'
      }
    },
    {
      path: `${basePath}/add`,
      component: Edit,
      meta: {
        isNewPage: true,
        isEditMode: false,
        titleI18nKey: 'admin.company.alumniManagement.title'
      }
    },
    {
      path: `${basePath}/edit/:alumniId`,
      component: Edit,
      meta: {
        isNewPage: true,
        isEditMode: true,
        titleI18nKey: 'admin.company.alumniManagement.title'
      }
    }
  ]
}
